import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=5b1fa9f3&lang=pug&"
import script from "./accounts.vue?vue&type=script&lang=coffee&"
export * from "./accounts.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports